import { connect } from 'react-redux';

import { isFetching } from 'shared/selectors/channels';
import { getPublic as getChannel } from 'shared/redux/server/actions/channel/get';

import DataLoader from 'shared/data-components/_data-loader';


@connect(state => ({
  isFetching: isFetching(state),
}), {
  getChannel,
})
export default class ChannelLoader extends DataLoader {

  static displayName = 'ChannelLoader';
  static propTypes = {
    getChannel: React.PropTypes.func,
    channelId: React.PropTypes.string,
  };

  dependencies = [
    'channelId',
  ];

  loadData() {
    const { channelId, getChannel } = this.props;

    if (!channelId) {
      return;
    }

    // TODO: move getChannel code here
    return getChannel(channelId);
  }

  get childProps() {
    const { isFetching } = this.props;
    return {
      channel: { isFetching, fetch: this.loadDataDebounced },
    };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/channel.js